import React from "react";
import { Config } from "../../../Utils/Config";
import { useNavigate } from "react-router-dom";

const DeniedAccess = () => {
  const navigate = useNavigate();
  return (
    <div className="auth-container-body">
      <div className="auth-container access-denied-sec">
        <h2 style={{ marginTop: "0" }}>Access Denied</h2>
        <p>
          Access has been denied by another session. Please check your open
          sessions or reset your password to ensure account security. You can
          also reach out to support at{" "}
          <a href={`mailto${Config.ContactUrl}`}>{Config.ContactUrl}</a> or go
          to <a href="http://www.rvparkiq.com">www.rvparkiq.com</a> and activate
          a CHAT session now or call {Config.ContactNo}.
        </p>
        <div className="footer-section">
          <div className="footer-contact">
            <button
              className="resend-btn"
              onClick={() => {
                localStorage.clear();
                navigate("/signin");
              }}
            >
              {" "}
              Back to Login{" "}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeniedAccess;
